import styled from "styled-components";

export const SearchContainer = styled.div`
  overflow-x: hidden;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 80px;
  background: white;
  min-height: 100vh;
`;

export const SearchSection = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
`;

export const SearchInputBox = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  background-color: #F5F5F5;
  border-radius: 25px;
  padding: 12px 20px;
  gap: 10px;
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  background: none;
  outline: none;
  font-size: 16px;
  color: #333;

  &::placeholder {
    color: #999;
  }
`;

export const SearchIcon = styled.div`
  font-size: 20px;
  color: #999;
  display: flex;
  align-items: center;
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  color: #999;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;

  &:hover {
    color: #666;
  }
`;

export const CancelButton = styled.button`
  background: none;
  border: none;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;

  &:hover {
    color: #666;
  }
`;

export const SearchContent = styled.div`
  padding: 0 20px 20px;
  text-align: left;
`;

export const SearchResults = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ResultCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  gap: 12px;
  position: relative;
`;

export const ResultImage = styled.div`
  width: 140px;
  height: 140px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ResultInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ResultHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ResultTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: left;
`;

export const ResultArrow = styled.div`
  font-size: 20px;
  color: #999;
  cursor: pointer;
`;

export const ResultLocation = styled.div`
  font-size: 14px;
  color: #666;
  text-align: left;
`;

export const ResultTime = styled.div`
  font-size: 14px;
  color: #666;
  text-align: left;
`;

export const ReserveButton = styled.button`
  margin-top: auto;
  background-color: #1FBC70;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  align-self: flex-end;

  &:hover {
    background-color: #1AAA64;
  }
`;

export const EmptyMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
`;
